<template>
  <div class="body">
    <article class="banner">
      <div class="desc">
        <h2>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
            width="150.6896514892578" height="46" viewBox="0 0 150.6896514892578 46">
            <defs>
              <clipPath id="master_svg0_184_12753">
                <rect x="0" y="0" width="150.6896514892578" height="46" rx="0" />
              </clipPath>
            </defs>
            <g clip-path="url(#master_svg0_184_12753)">
              <g>
                <path
                  d="M131.221,0L118.183,0L99.7264,18.2856L81.2634,0L75.2475,0L96.7152,21.2614L71.7366,46L84.7743,46L103.231,27.7208L121.694,46L127.71,46L106.242,24.7386L131.221,0ZM17.1651,23.2924L18.6058,18.1634L14.6731,18.1634L15.3805,11.6269L17.2884,11.6269L18.7291,6.50435L15.9386,6.50435L16.2955,3.25858L11.1168,3.25858L10.7274,6.50435L5.62004,6.50435L4.61414,11.6269L10.1044,11.6269L10.0265,12.2889L5.79525,12.2889L0,39.9005L5.19821,39.9005L8.7156,23.1317L6.07431,45.068L11.9994,42.7606L14.115,23.2924L17.1651,23.2924ZM56.8234,34.7714L56.2782,39.9004L74.0923,39.9004L79.2646,34.7714L70.3413,34.7714L71.8923,20.1558L82.4121,20.1558L82.9572,15.0269L72.4375,15.0269L73.6056,3.99766L67.7844,5.70089L66.9278,15.0269L56.7325,15.0269L56.1874,20.1558L66.454,20.1558L65.1107,34.7714L56.8234,34.7714ZM23.7392,10.2709L24.161,9.32606L18.6967,9.32606L20.1374,4.1971L29.489,4.1971L30.8324,8.2977L25.6926,19.5197L19.6507,19.5197L21.4743,15.3998L17.3339,15.3998L18.7811,10.2709L23.7392,10.2709ZM26.8412,19.5454L28.8919,14.4229L35.375,14.4229L32.9674,4.1971L38.3798,4.1971L38.6653,5.41185L48.2959,5.41185L46.8487,10.5344L39.8724,10.5344L40.0736,11.3828L45.5184,11.3828L44.0777,16.5053L41.2806,16.5053L42.001,19.5454L36.5821,19.5454L36.2252,18.0157L35.4594,19.5454L26.8412,19.5454ZM52.1378,4.1971L57.4139,4.1971L52.4493,15.0271L55.149,15.0271L51.9691,43.7184L46.083,44.9203L49.1007,21.7564L44.0907,21.7564L52.1378,4.1971ZM148.275,23.7487L150.657,8.83743C150.761,8.18828,150.625,7.63553,150.242,7.17277C149.859,6.71001,149.346,6.47863,148.691,6.47863L128.91,6.47863L126.496,8.86957L142.668,8.86957C143.194,8.86957,143.421,9.13309,143.337,9.6537L141.468,21.3513L123.083,21.3513L120.837,35.3885L125.607,40.1126L146.03,40.1126L146.406,37.7602L127.716,37.7602L129.955,23.7423L148.269,23.7423L148.275,23.7487ZM42.6175,20.3295L40.5928,32.0014L35.3232,32.0014L36.7769,25.4584L24.5309,25.4584L24.3816,26.8724L35.0052,26.8724L33.5645,32.0014L17.9049,32.0014L19.9232,20.3295L42.6175,20.3295ZM33.7526,32.6826L38.9963,32.6826L38.2305,34.7715L45.5898,34.7715L45.0446,39.9004L13.2908,39.9004L13.8359,34.7715L21.8247,34.7715L21.5002,32.6826L26.6919,32.6826L27.0099,34.7715L32.9869,34.7715L33.7526,32.6826Z"
                  fill-rule="evenodd" fill="#FF3F00" fill-opacity="1" />
              </g>
            </g>
          </svg>
        </h2>
        <p class="slogan">
          安全车身 智能网联 舒适配置
        </p>
        <ul class="tab">
          <li>
            <h3>4.4m³</h3>
            <p>货箱容积</p>
          </li>
          <li class="left">
            <h3>1700kg</h3>
            <p>大载重</p>
          </li>
          <li class="left">
            <h3>180km</h3>
            <p>续航里程</p>
          </li>
        </ul>
        <div class="buttonArea">
          <!-- <div class="buttonGo" @click="showPopup">预约抢购</div> -->
          <div class="buttonGo" @click="handleScroll">详细参数</div>
        </div>
      </div>

      <picture style="width: 100%">
        <source srcset="
            https://juzhen-store.oss-cn-beijing.aliyuncs.com/2024/x2/pc/two.jpg
          " media="all and (max-width: 500px)" type="image/jpg" />
        <img src="https://juzhen-store.oss-cn-beijing.aliyuncs.com/2024/x2/pc/two.jpg" width="1960" height="640" />
      </picture>
    </article>

    <section class="bigRoom">
      <div class="desc">
        <h3>容积大 巨能装</h3>
        <p>极致的空间设计，合理配置空间</p>
      </div>
      <div class="right">
        <img src="https://juzhen-store.oss-cn-beijing.aliyuncs.com/2024/x2/pc/room.png" alt="" srcset="" />
      </div>
    </section>

    <section class="passThrough">
      <div class="left">
        <img src="https://juzhen-store.oss-cn-beijing.aliyuncs.com/2024/x2/pc/passThrough.jpg" alt="" />
      </div>
      <div class="right">
        <h3>轻松通行</h3>
        <p>车身窄，轻松通过窄街小巷</p>
      </div>
    </section>

    <section class="mass">
      <picture style="width:100%;">
        <source data-v-da7103cc="" srcset="
            https://juzhen-store.oss-cn-beijing.aliyuncs.com/2024/x2/pc/bg2.jpg 1x
          " media="all and (max-width: 500px)" type="image/png" />
        <img data-v-da7103cc="" src="https://juzhen-store.oss-cn-beijing.aliyuncs.com/2024/x2/pc/bg2.jpg" width="100%"
          height="40%" class="designBanner" style="max-height:610px;" />
      </picture>
      <div class="desc">
        <h3>质量好配置高</h3>
        <p>乘用级安全车身、智能网联舒适配置应有尽有</p>
      </div>

      <div class="car">
        <img src="https://juzhen-store.oss-cn-beijing.aliyuncs.com/2024/x2/pc/mass.png" alt="">
      </div>
    </section>

    <section class="parameter" ref="parameter">
      <div class="title">
        <h3>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1"
            width="150.6896514892578" height="46" viewBox="0 0 150.6896514892578 46">
            <defs>
              <clipPath id="master_svg0_184_16736">
                <rect x="0" y="0" width="150.6896514892578" height="46" rx="0" />
              </clipPath>
            </defs>
            <g clip-path="url(#master_svg0_184_16736)">
              <g>
                <path
                  d="M131.221,0L118.183,0L99.7264,18.2856L81.2634,0L75.2475,0L96.7152,21.2614L71.7366,46L84.7743,46L103.231,27.7208L121.694,46L127.71,46L106.242,24.7386L131.221,0ZM17.1651,23.2924L18.6058,18.1634L14.6731,18.1634L15.3805,11.6269L17.2884,11.6269L18.7291,6.50435L15.9386,6.50435L16.2955,3.25858L11.1168,3.25858L10.7274,6.50435L5.62004,6.50435L4.61414,11.6269L10.1044,11.6269L10.0265,12.2889L5.79525,12.2889L0,39.9005L5.19821,39.9005L8.7156,23.1317L6.07431,45.068L11.9994,42.7606L14.115,23.2924L17.1651,23.2924ZM56.8234,34.7714L56.2782,39.9004L74.0923,39.9004L79.2646,34.7714L70.3413,34.7714L71.8923,20.1558L82.4121,20.1558L82.9572,15.0269L72.4375,15.0269L73.6056,3.99766L67.7844,5.70089L66.9278,15.0269L56.7325,15.0269L56.1874,20.1558L66.454,20.1558L65.1107,34.7714L56.8234,34.7714ZM23.7392,10.2709L24.161,9.32606L18.6967,9.32606L20.1374,4.1971L29.489,4.1971L30.8324,8.2977L25.6926,19.5197L19.6507,19.5197L21.4743,15.3998L17.3339,15.3998L18.7811,10.2709L23.7392,10.2709ZM26.8412,19.5454L28.8919,14.4229L35.375,14.4229L32.9674,4.1971L38.3798,4.1971L38.6653,5.41185L48.2959,5.41185L46.8487,10.5344L39.8724,10.5344L40.0736,11.3828L45.5184,11.3828L44.0777,16.5053L41.2806,16.5053L42.001,19.5454L36.5821,19.5454L36.2252,18.0157L35.4594,19.5454L26.8412,19.5454ZM52.1378,4.1971L57.4139,4.1971L52.4493,15.0271L55.149,15.0271L51.9691,43.7184L46.083,44.9203L49.1007,21.7564L44.0907,21.7564L52.1378,4.1971ZM148.275,23.7487L150.657,8.83743C150.761,8.18828,150.625,7.63553,150.242,7.17277C149.859,6.71001,149.346,6.47863,148.691,6.47863L128.91,6.47863L126.496,8.86957L142.668,8.86957C143.194,8.86957,143.421,9.13309,143.337,9.6537L141.468,21.3513L123.083,21.3513L120.837,35.3885L125.607,40.1126L146.03,40.1126L146.406,37.7602L127.716,37.7602L129.955,23.7423L148.269,23.7423L148.275,23.7487ZM42.6175,20.3295L40.5928,32.0014L35.3232,32.0014L36.7769,25.4584L24.5309,25.4584L24.3816,26.8724L35.0052,26.8724L33.5645,32.0014L17.9049,32.0014L19.9232,20.3295L42.6175,20.3295ZM33.7526,32.6826L38.9963,32.6826L38.2305,34.7715L45.5898,34.7715L45.0446,39.9004L13.2908,39.9004L13.8359,34.7715L21.8247,34.7715L21.5002,32.6826L26.6919,32.6826L27.0099,34.7715L32.9869,34.7715L33.7526,32.6826Z"
                  fill-rule="evenodd" fill="#FF3F00" fill-opacity="1" />
              </g>
            </g>
          </svg>
          <span>详细参数</span>
        </h3>
      </div>

      <div class="content">

        <table>
          <thead>
            <tr>
              <th>车型</th>
              <th>橙仕X2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>尺寸（长*宽*高）（mm）</td>
              <td>4200*1570*1995</td>
            </tr>
            <tr class="bg">
              <td>前后轮距（mm）</td>
              <td>1250</td>
            </tr>
            <tr>
              <td>最大总质量（kg）</td>
              <td>1700</td>
            </tr>
            <tr class="bg">
              <td>货箱容积（m³）</td>
              <td>≈ 4.4</td>
            </tr>
            <tr>
              <td>最大爬坡度（°）</td>
              <td>＜20</td>
            </tr>
            <tr class="bg">
              <td>最高车速（km/h）</td>
              <td>71</td>
            </tr>
            <tr class="spec">
              <td>电池总电量（kWh）</td>
              <td>10/20</td>
            </tr>
            <tr class="bg">
              <td>综合工况续航里程（km）</td>
              <td>120/180</td>
            </tr>
            <tr>
              <td>BMS电池管理系统</td>
              <td>支持</td>
            </tr>
            <tr class="bg">
              <td>质保（电机、电控、电池）（km）</td>
              <td>5年/20万</td>
            </tr>
          </tbody>
        </table>
      </div>

    </section>

    <!-- <div class="box volumeBox">
      <div class="layout">
        <div class="inner">
          <div class="summary">
            <h3>容积大</h3>
            <p>巨能装，双倍容积，适合大件运输</p>
          </div>
          <img src="../../assets/v4/x2/x2_1.png" width="1170" height="700" />
        </div>
      </div>
    </div>

    <div class="box passBox">
      <div class="layout">
        <div class="inner">
          <div class="summary">
            <h3>轻松通行</h3>
            <p>车身窄，轻松通过窄街小巷</p>
          </div>
          <div class="img">
            <img src="../../assets/v4/x2/x2_2.jpg" width="980" height="840" />
          </div>
        </div>
      </div>
    </div>

    <div class="box qualityBox">
      <div class="layout">
        <div class="inner">
          <div class="summary">
            <h3>质量好配置高</h3>
            <p>
              乘用级安全车身<span class="mHide">、</span
              ><br class="mShow" />智能网联舒适配置应有尽有
            </p>
          </div>
          <img src="../../assets/v4/x2/x2_3.png" width="1130" height="530" />
        </div>
      </div>
    </div>

    <div class="box paramsBox">
      <div class="layout">
        <div class="inner">
          <div class="img">
            <img src="../../assets/v4/x2/x2_4.png" width="950" height="580" />
          </div>
          <div class="params">
            <h3>性能参数</h3>
            <ul class="list">
              <li>
                <span class="t">尺寸参数(mm)</span>
                <span class="v">4200×1570×1995</span>
              </li>
              <li>
                <span class="t">综合工況续航里程(km)</span>
                <span class="v">120/180</span>
              </li>
              <li>
                <span class="t">动力电池总电量(kWh)</span>
                <span class="v">10/20</span>
              </li>
              <li>
                <span class="t">前/后轮距(mm)</span>
                <span class="v">1250/1250</span>
              </li>
              <li>
                <span class="t">最高时速(km/h)</span>
                <span class="v">71</span>
              </li>
              <li>
                <span class="t">BMS电池管理系统</span>
                <span class="v">支持</span>
              </li>
              <li>
                <span class="t">最大总质量(kg)</span>
                <span class="v">1700</span>
              </li>
              <li>
                <span class="t">最大爬坡度(%</span>
                <span class="v">>20</span>
              </li>
              <li>
                <span class="t">货厢容积(m)</span>
                <span class="v">约4.4</span>
              </li>
              <li>
                <span class="t">质保(电机、电控、动力电池）(km）</span>
                <span class="v">5年/20万</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->

    <transition name="modal">
      <div class="popup" v-if="popupShow">
        <div class="popupMasker"></div>
        <div class="popupContent">
          <div class="bookView" v-show="!submited">
            <span class="close" @click="hidePopup"></span>
            <div class="tips">
              <h3 class="title">订购说明</h3>
              <p>请如实填写申请资料，我们的销售人员会及时和你联系订购信息</p>
            </div>

            <form @submit="submitPopup">
              <ul class="formList">
                <li class="item">
                  <label for="name">姓名</label>
                  <div class="input">
                    <input id="name" v-model.trim="formData.name" name="name" type="text" maxlength="20"
                      placeholder="请输入你的姓名" />
                    <p class="error" v-show="formDataCheck.name">
                      请输入你的姓名
                    </p>
                  </div>
                </li>
                <li class="item">
                  <label for="mobile">手机号</label>
                  <div class="input">
                    <input id="mobile" v-model.trim="formData.mobile" name="mobile" type="text" maxlength="20"
                      placeholder="请输入你的手机号" />
                    <p class="error" v-show="formDataCheck.mobile">
                      请输入你的手机号
                    </p>
                  </div>
                </li>
                <li class="item" style="border-bottom: none">
                  <label for="area">所在城市</label>
                  <div class="input">
                    <input id="area" v-model.trim="formData.area" name="area" type="text" maxlength="20"
                      placeholder="请输入所在城市" />
                    <p class="error" v-show="formDataCheck.area">
                      请输入所在城市
                    </p>
                  </div>
                </li>
              </ul>
              <ul class="formList">
                <li class="item itemShow">
                  <label for="remark">备注</label>
                  <textarea id="remark" v-model.trim="formData.remark" name="remark"
                    placeholder="请输入需要备注的信息"></textarea>
                </li>
              </ul>
              <div class="formBtnLine">
                <button class="btn" type="submit">申请订购</button>
              </div>
            </form>
          </div>

          <div class="backView" v-show="submited">
            <template v-if="success">
              <img class="icon" src="https://juzhen-store.oss-cn-beijing.aliyuncs.com/2021/02/09/icon_success.png"
                width="60" height="60" />
              <h2 class="title">恭喜您，提交成功！</h2>
              <p>我们的销售人员会在1-3个工作日和您联系</p>
            </template>
            <template v-else>
              <img class="icon" src="https://juzhen-store.oss-cn-beijing.aliyuncs.com/2021/02/09/icon_fail.png"
                width="60" height="60" />
              <h2 class="title">Sorry，提交失败~</h2>
            </template>
            <div class="btnLine">
              <button class="btn" type="button" @click="hidePopup">
                知道了
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "csX2",
  data () {
    return {
      formData: {
        name: "",
        mobile: "",
        area: "",
        remark: "",
      },
      formDataCheck: {
        name: false,
        mobile: false,
        area: false,
      },
      popupShow: false,
      submited: false,
      success: false,
    };
  },
  methods: {
    showPopup () {
      this.popupShow = true;
      this.submited = false;
    },
    hidePopup () {
      this.popupShow = false;
      this.submited = false;
    },
    handleScroll () {
      this.$refs.parameter.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    submitPopup (e) {
      e.preventDefault();

      const { formData, formDataCheck } = this;
      let verify;

      Object.keys(formDataCheck).forEach((key) => {
        formDataCheck[key] = !formData[key];

        if (formDataCheck[key]) {
          verify = true;
        }
      });

      if (verify) return;

      this.axios({
        url: "https://api.partner.juzhen.cn/api/api/preorder/save",
        method: "post",
        data: {
          count: 1,
          prodId: 83,
          ...formData,
        },
      }).then((data) => {
        this.submited = true;
        this.success = data.code === 200;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.parameter {
  max-width: 1960px;
  margin: 0 auto;
  background: #fff;

  .title {
    margin-bottom: 64px;

    h3 {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 36px;
        font-weight: normal;
        margin-left: 24px;
      }
    }
  }

  img {
    width: 69%;
    display: block;
    margin: 0 auto;
    margin-bottom: 64px;
  }

  .content {
    width: 86%;
    margin: 0 auto;
    margin-bottom: 80px;

    table {
      width: 100%;
      /* 设置表格宽度为100% */
      table-layout: fixed;
      /* 使用固定布局 */

      thead {
        background: #F6F6F6;
        height: 58px;
        border-width: 1px 0px 1px 0px;
        border-style: solid;
        border-color: #999999;

        th {
          text-indent: 8px;
          line-height: 58px;
          font-size: 24px;
          font-weight: 800;
        }
      }

      tbody {
        tr {
          text-indent: 8px;
          height: 52px;
          font-size: 18px;
          color: #3D3D3D;
        }

        .bg {
          background: #F6F6F6;
        }
      }
    }
  }
}

.mass {
  max-width: 1960px;
  margin: 0 auto;

  .car {
    width: 58%;
    margin: 0 auto;
    margin-bottom: 28px;

    img {
      width: 100%;
    }
  }

  .desc {
    margin-top: -530px;
    margin-bottom: 90px;

    h3 {
      text-align: center;
      font-size: 64px;
      font-weight: 600;
      color: #1A1A1A;
      line-height: 90px;
    }

    p {
      text-align: center;
      font-size: 24px;
    }
  }
}

.bigRoom {
  padding: 57px 51px 10px 102px;
  background: #c9e3e5;
  display: flex;

  max-width: 1960px;
  margin: 0 auto;

  img {
    width: 100%;
  }

  .right {
    flex: 1;
  }

  .desc {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h3 {
      font-size: 64px;
      font-weight: 600;
      color: #1a1a1a;
      margin-bottom: 8px;
    }

    p {
      font-size: 24px;
      font-weight: 250;
      color: #1a1a1a;
    }
  }
}

.passThrough {
  display: flex;
  background: #ffdec5;
  max-width: 1960px;
  margin: 0 auto;

  .left {
    flex: 1;
    border-left: 80px solid #ffdec5;
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 100px;
    padding-bottom: 100px;

    h3 {
      font-size: 64px;
      font-weight: 600;
      color: #1a1a1a;
      margin-bottom: 8px;
    }

    p {
      font-size: 24px;
      font-weight: 250;
      color: #1a1a1a;
    }
  }

  img {
    width: 100%;
    height: 100%;
  }
}

.layout {
  .inner {
    margin-left: auto;
    margin-right: auto;
    max-width: 1440px;
  }
}

.popup {
  position: relative;
  z-index: 999;
}

.popupMasker,
.popupContent {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.popupMasker {
  background-color: rgba(0, 0, 0, 0.7);
  pointer-events: auto;
}

.popupContent {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.bookView,
.backView {
  position: relative;
  margin: 36px;
  padding: 16px;
  background-color: #f7f8f9;
  border-radius: 16px;
}

.bookView {
  .close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    transition: transform 0.3s;
    cursor: pointer;

    &:hover {
      transform: rotate(180deg);
    }

    &::before,
    &::after {
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -1px;
      width: 100%;
      height: 2px;
      content: "";
      transform: rotate(45deg);
      background-color: #979797;
    }

    &::after {
      transform: rotate(-45deg);
    }
  }

  .tips {
    margin-bottom: 20px;
    padding: 0 36px 0 16px;
    font-size: 14px;
    color: #949b9c;
    line-height: 16px;

    .title {
      display: block;
      margin-bottom: 8px;
      font-size: 16px;
      color: #323334;
      line-height: 36px;
    }
  }
}

.backView {
  padding: 24px 16px;
  font-size: 14px;
  color: #949b9c;
  text-align: center;
  line-height: 16px;

  .title {
    display: block;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 24px;
    color: #323334;
  }

  .btnLine {
    margin: 40px auto 0;
    width: 50%;

    .btn {
      display: block;
      width: 100%;
      height: 32px;
      padding: 0;
      font-size: 14px;
      color: #ffffff;
      line-height: 32px;
      border-radius: 28px;
      background: #e83e0b;
      border: none;
      outline: none;
    }
  }
}

.formList {
  margin: 12px 0;
  padding: 10px 16px;
  background-color: #fff;
  border-radius: 8px;

  .item {
    display: flex;
    flex-wrap: wrap;
    line-height: 40px;
    border-bottom: 1px solid #d8d8d8;

    label {
      width: 80px;
      font-size: 14px;
      color: #323334;
      font-weight: bold;
    }

    .error {
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      color: #f00;
    }
  }

  .itemBlock {
    display: block;
    border-bottom: none;
  }

  .input {
    flex: 1;
    padding: 4px 0;

    input {
      display: block;
      padding: 4px 0;
      width: 100%;
      font-size: 14px;
      line-height: 24px;
      border: none;
      outline: none;
    }
  }

  textarea {
    display: block;
    width: 100%;
    font-size: 14px;
    line-height: 24px;
    border: none;
    outline: none;
    resize: none;
  }
}

.formBtnLine {
  margin: 16px;

  .btn {
    display: block;
    width: 100%;
    height: 40px;
    padding: 0;
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
    border-radius: 28px;
    background: #e83e0b;
    border: none;
    outline: none;
  }
}

.banner {
  margin: 0 auto;
  max-width: 1960px;
  // padding: 235px 0 40px;
  text-align: center;
  font-size: 25px;
  line-height: 51px;
  background-color: #f0f0f0;
  position: relative;

  h2 {
    font-size: 80px;
    font-weight: normal;
    line-height: 100px;
    font-family: PingFangSC-Ultralight;
    margin-bottom: 2px;
  }

  .slogan {
    font-size: 64px;
    color: #000;
    font-weight: 250;
    line-height: 90px;
    margin-bottom: 24px;
  }

  .tab {
    display: flex;
    margin-bottom: 24px;

    h3 {
      font-size: 32px;
      font-weight: 600;
    }

    p {
      font-size: 14px;
      font-weight: 300;
      line-height:24px;
    }

    .left {
      margin-left: 64px;
    }
  }

  .descT {
    color: #ffffff;
    font-size: 24px;
    font-weight: 300;
    margin-bottom: 24px;
  }

  .buttonArea {
    display: flex;

    .buttonGo {
      padding: 6px 16px;
      border: 1px solid #000;
      font-size: 14px;
      color: #000;
      line-height: 20px;
    }

    .left {
      margin-left: 12px;
    }
  }

  .btnBook {
    display: inline-block;
    margin: 40px auto 30px;
    vertical-align: top;
    padding: 0 60px;
    line-height: 60px;
    font-size: 34px;
    color: #fff;
    border-radius: 60px;
    background-image: linear-gradient(#f34600 0%, #ef2e00 100%);
    cursor: pointer;
  }

  .desc {
    width: 100%;
    position: absolute;
    top: 10%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.banner,
.box {
  img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    height: auto;
  }
}

.volumeBox {
  margin-bottom: #{"min(18%, 350px)"};
  background-color: #c5dbdd;

  .inner {
    position: relative;
    padding: 12.5% 20px 15.625%;

    .summary {
      position: relative;
      padding-bottom: 8px;
      z-index: 5;
    }

    img {
      position: absolute;
      right: 0;
      top: 33.3334%;
      width: 81.25%;
      z-index: 1;
    }
  }
}

.passBox {
  margin-bottom: #{"min(10%, 180px)"};

  .layout {
    padding: 0;
  }

  .inner {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;

    .summary {
      flex: 46;
      padding: 30px 40px;
      background-color: #fff;
      min-width: 380px;
      transform: translateX(-100px);
    }

    .img {
      flex: 98;
    }
  }
}

.qualityBox {
  margin-bottom: 300px;
  background-color: #e2491c;

  .inner {
    padding-top: 10%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .summary {
      margin-bottom: -70px;
      color: #fff;
      text-align: center;

      h3 {
        color: #fff;
      }
    }

    img {
      position: relative;
      top: 160px;
      max-width: 80%;
    }
  }
}

.paramsBox {
  margin-bottom: 160px;

  .inner {
    display: flex;

    .img {
      position: relative;
      left: -20px;
      flex: 95;
    }

    .params {
      flex: 49;
      min-width: 470px;

      h3 {
        margin-bottom: 24px;
        font-size: 22px;
        line-height: 28px;
      }

      .list {
        border-top: 1px dashed #666;

        li {
          display: flex;
          justify-content: space-between;
          font-size: 20px;
          line-height: 44px;
          color: #666;
          border-bottom: 1px dashed #666;
        }
      }
    }
  }
}

@media only screen and (max-width: 500px) {
  .banner {
    margin: 0 auto;
    max-width: 1960px;
    // padding: 235px 0 40px;
    text-align: center;
    font-size: 25px;
    line-height: 51px;
    background-color: #f0f0f0;
    position: relative;

    h2 {
      font-size: 40px;
      font-weight: normal;
      line-height: 40px;
      font-family: PingFangSC-Ultralight;
      margin-bottom: 0px;

      svg {
        width: 100px;
      }

    }

    .tab {
      display: flex;
      margin-bottom: 0px;

      h3 {
        font-size: 18px;
        font-weight: 600;
      }

      p {
        font-size: 12px;
        font-weight: 300;
      }

      .left {
        margin-left: 12px;
      }
    }


    .slogan {
      font-size: 14px;
      color: #000;
      font-weight: 800;
      line-height: 14px
    }

    .descT {
      color: #FFFFFF;
      font-size: 12px;
      font-weight: 300;
      margin-bottom: 0px;
    }

    .buttonArea {
      display: flex;

      .buttonGo {
        padding: 2px 8px;
        border: 1px solid #000;
        font-size: 12px;
        color: #000;
        line-height: 20px;
      }

      .left {
        margin-left: 12px;
      }
    }

    .btnBook {
      display: inline-block;
      margin: 40px auto 30px;
      vertical-align: top;
      padding: 0 60px;
      line-height: 60px;
      font-size: 34px;
      color: #fff;
      border-radius: 60px;
      background-image: linear-gradient(#f34600 0%, #ef2e00 100%);
      cursor: pointer;
    }

    .desc {
      width: 100%;
      position: absolute;
      top: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  .bigRoom {
    padding: 57px 0;
    background: #c9e3e5;
    display: block;

    max-width: 1960px;
    margin: 0 auto;

    img {
      width: 100%;
    }

    .right {
      flex: 1;
    }

    .desc {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      h3 {
        font-size: 32px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 8px;
      }

      p {
        font-size: 18px;
        font-weight: 250;
        color: #1a1a1a;
        margin-bottom: 24px;
      }
    }
  }

  .passThrough {
    display: block;
    background: #ffdec5;
    max-width: 1960px;
    margin: 0 auto;

    .left {
      flex: 1;
      border-left: 0px solid #ffdec5;
    }

    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 100px;
      padding-bottom: 100px;

      h3 {
        font-size: 32px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 8px;
      }

      p {
        font-size: 12px;
        font-weight: 250;
        color: #1a1a1a;
      }
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .mass {
    max-width: 1960px;
    margin: 0 auto;

    .car {
      width: 58%;
      margin: 0 auto;
      margin-bottom: 28px;

      img {
        width: 100%;
      }
    }

    .desc {
      margin-top: -180px;
      margin-bottom: 90px;

      h3 {
        text-align: center;
        font-size: 24px;
        font-weight: 600;
        color: #1A1A1A;
        line-height: 40px;
      }

      p {
        text-align: center;
      }
    }
  }

  .parameter {
  max-width: 1960px;
  margin: 0 auto;
  background: #fff;

  .title {
    margin-bottom: 64px;

    h3 {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 36px;
        font-weight: normal;
        margin-left: 24px;
      }
    }
  }

  img {
    width: 69%;
    display: block;
    margin: 0 auto;
    margin-bottom: 64px;
  }

  .content {
    width: 86%;
    margin: 0 auto;
    margin-bottom: 80px;

    table {
      width: 100%;
      /* 设置表格宽度为100% */
      table-layout: fixed;
      /* 使用固定布局 */

      thead {
        background: #F6F6F6;
        height: 58px;
        border-width: 1px 0px 1px 0px;
        border-style: solid;
        border-color: #999999;

        th {
          text-indent: 8px;
          line-height: 58px;
          font-size: 12px;
          font-weight: 800;
        }
      }

      tbody {
        tr {
          text-indent: 8px;
          height: 52px;
          font-size: 10px;
          color: #3D3D3D;
        }

        .bg {
          background: #F6F6F6;
        }
      }
    }
  }
}
}
</style>
